import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kreonet.placeholder.card');
import { OnInit } from '@angular/core';

@Component({
    selector: 'wiz-portal-kreonet-placeholder-card',
template: templateSource || '',
    styles: [``],
})
export class PortalKreonetPlaceholderCardComponent implements OnInit {
    public ngOnInit() {
    }
}

export default PortalKreonetPlaceholderCardComponent;